/**
 * Button — in-page button (fallback / secondary actions).
 * The single primary action per screen is normally the native Telegram
 * MainButton (see tg.MainButton); use this for secondary/ghost actions or as
 * the primary when running in a plain browser without a MainButton.
 *
 * Props:
 *   variant?  'primary' | 'ok' | 'bad' | 'secondary' | 'ghost'  (default 'primary')
 *   onClick   fn
 *   disabled? bool
 *   type?     button type (default 'button')
 *   children  label
 */
export default function Button({
  variant = 'primary',
  onClick,
  disabled = false,
  type = 'button',
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={`btn btn--${variant}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
